import React, { Suspense } from 'react';

import {
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { useAuthContext } from "../Contexts/AuthProvider";

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Box from '@mui/material/Box';

import ScriptRouter from "../Router/ScriptRouter";
import SessionRouter from "../Router/SessionRouter";

import Header from "./HeaderTailwind";
import GradientLine from './GradientLine';

const RecordPage = React.lazy(() => import("../Record/RecordPage"));
const ProfilePage = React.lazy(() => import("../Profile/ProfilePage"));

const PortfolioPage = React.lazy(() => import("../Portfolio/Portfolio"));

const SessionsPage = React.lazy(() => import("../Session/Sessions"));
//const ScriptsPage = React.lazy(() => import("../Scripts/Scripts"));
const ScriptsPage = React.lazy(() => import("../FreeScripts/Scripts"));
const ScriptEditorPage = React.lazy(() => import("../ScriptEditor/ScriptEditor"));

const FreeScriptsPage = React.lazy(() => import("../FreeScripts/Scripts"));

const AudioPage = React.lazy(() => import("../Audio/Audios"));
const AudioEditorPage = React.lazy(() => import("../Audio/AudioEditor"));

const DocumentsPage = React.lazy(() => import("../Write/Documents"));
const WritePage = React.lazy(() => import("../Write/WritePage"));

//const TemplatesPage = React.lazy(() => import("../Templates/Templates"));
//const TemplateEditorPage = React.lazy(() => import("../Templates/TemplateEditor"));
const TemplatePage = React.lazy(() => import("../Templates/Template"));

const FriendsPage = React.lazy(() => import("../Friends/FriendsTailwind"));

const NotificationPage = React.lazy(() => import("../Notification/Notifications"));

const LoginPage = React.lazy(() => import("../Login/LoginTailwind"));
const SignupPage = React.lazy(() => import("../Login/SignupTailwind"));

const AboutPage = React.lazy(() => import("../Misc/About"));
const GuidePage = React.lazy(() => import("../Misc/Guide"));
const ContactPage = React.lazy(() => import('../Misc/ContactTailwind'));

const PublishPage = React.lazy(() => import('../Misc/Publish'));

const FaqPage = React.lazy(() => import('../Misc/Faq'));
const MetricsPage = React.lazy(() => import('../Misc/Metrics'));
const MembershipPage = React.lazy(() => import('../Misc/Membership'));
const PaymentPage = React.lazy(() => import('../Misc/Subscription'));

const AzureSignIn = React.lazy(() => import('../Misc/Azure/SignIn'));
const AzureSignOut = React.lazy(() => import('../Misc/Azure/SignOut'));

//const FreeSoundPOC = React.lazy(() => import('../Misc/FreeSoundPOC'));

const CertificatePage = React.lazy(() => import('../Events/Certificate'));
const CertificateSearchPage = React.lazy(() => import('../Events/CertificateSearch'));

//const EventPage = React.lazy(() => import('../Events/Event'));
//const EventsPage = React.lazy(() => import('../Events/EventsTailwind'));
//const RegistrationPage = React.lazy(() => import('../Events/Registration'));

export default function MainSite() {
  const { token, hasPrivilege } = useAuthContext();

  //  const navigate = useNavigate();

  const theme = createTheme({
    palette: {
      button: {
        main: 'black'
      },
      modal: {
        main: '#fff'
      },
      theme: {
        main: "#00bfff"
      }
    }
  });

  const loggedIn = token !== null;

  const routesWithHeader = () => {
    return (
      <>
        {
          loggedIn &&
          <>
            <Route path="/scripts/edit/:scriptId" element={<ScriptEditorPage />} />
            <Route path="/scripts/create" element={<ScriptEditorPage />} />

            {hasPrivilege('audio_library') &&
              <>
                <Route path="/audiolibrary" element={<AudioPage />} />
                <Route path="/audiolibrary/edit/:audioId" element={<AudioEditorPage />} />
                <Route path="/audiolibrary/create/:type" element={<AudioEditorPage />} />
              </>
            }

            {hasPrivilege('show_metrics') &&
              <Route path="/metrics" element={<MetricsPage />} />
            }

            {hasPrivilege('read_free_script') &&
              <Route path="/free_scripts2" element={<FreeScriptsPage />} />
            }

            <Route path="/scripts" element={<ScriptsPage />} />
            <Route path="/write" element={<DocumentsPage archived={false} />} />
            <Route path="/archive" element={<DocumentsPage archived={true} />} />
            <Route path="/history" element={<SessionsPage />} />
            <Route path="/friends" element={<FriendsPage />} />
            <Route path="/notifications" element={<NotificationPage />} />
          </>
        }
        
        <Route path="/membership-upgrade" element={<PaymentPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/membership" element={<MembershipPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/scriptlibrary" element={<FreeScriptsPage />} />

        <Route path="*" element={<Navigate to="/login" replace />} />
      </>
    );
  }

//  <Route path="/event/:eventId" element={<EventPage />} />
//  <Route path="/events" element={<EventsPage />} />
//  <Route path="/event/:eventId/register" element={<RegistrationPage />} />
//      <Route path='/freesound-poc' element={<FreeSoundPOC />} />


  /*
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="/templates/edit/:templateId" element={<TemplateEditorPage />} />
            <Route path="/templates/create" element={<TemplateEditorPage />} />
        <Route path="/certificate" element={<CertificateSearchPage />} />
  */

  const routesWithoutHeader = () => {
    return (
      <>
        <Route path="/certificate/:certId" element={<CertificatePage />} />

        <Route path="/contact" element={<ContactPage />} />

        <Route path="/publish" element={<PublishPage />} />

        <Route path="/login" element={loggedIn ? <Navigate to="/scripts" replace={true} /> : <LoginPage mode='login' />} />,
        <Route path="/register" element={loggedIn ? <Navigate to="/scripts" replace={true} /> : <SignupPage mode='signup' />} />,

        <Route path="/members/:handle" element={<ProfilePage />} />
        <Route path="/profile/:userId" element={<ProfilePage />} />

        <Route path="/portfolio/:userId" element={<PortfolioPage />} />

        <Route path="/session/:sessionId" element={<RecordPage />} />
        <Route path="/write/:documentId" element={<WritePage />} />
        <Route path="/template/:templateId" element={<TemplatePage />} />

        <Route path="/s/:linkId" element={<SessionRouter />} />
        <Route path="/script/:scriptId" element={<ScriptRouter />} />

        <Route path="/" element={<Navigate to={loggedIn ? "/scripts" : '/login'} replace={true} />} />

        <Route path="/auth/ms/login" element={<AzureSignIn />} />
        <Route path="/auth/ms/logout" element={<AzureSignOut />} />
      </>
    );
  }

  const overlayRoutes = () => {
    return (
      <>
      </>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          position: 'absolute', top: '0px', left: '0px', right: '0px',
          minHeight: '100dvh',
          display: 'flex',
          justifyContent: 'center'
        }}>
        <Box sx={{
          width: { 'xs': '100%', 'md': '100%' },
          position: 'relative',
          backgroundColor: '#e2e2e2',
          display: 'flex'
        }}>
          <GradientLine sx={{ position: 'absolute', left: '0px', right: '0px', top: '0px' }} />

          <Suspense fallback={<div />}>
            <Routes>
              {routesWithoutHeader()}

              <Route path="*" element={
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      height: '100%'
                    }}>
                    <Header />

                    <Box sx={{ flexGrow: 1, display:'flex' }}>
                      <Suspense fallback={<div />}>
                        <Routes>
                          {routesWithHeader()}
                        </Routes>
                      </Suspense>
                    </Box>
                  </Box>

                  <Suspense fallback={<div />}>
                    <Routes>
                      {overlayRoutes()}
                    </Routes>
                  </Suspense>
                </>
              } />
            </Routes>
          </Suspense>
        </Box>
      </div>
    </ThemeProvider>
  );
}